import { Navigate, useParams } from "react-router-dom";

export function SummaryPageRedirection() {
  const params = useParams()
  return <Navigate to={`/form/${params.reportId}/summary`}/>
}
